import {combineReducers} from "redux";

import foodlabel from "../features/admin/food_services/food_label/Slice";

import foodservice from "../features/admin/food_services/food_service/Slice";

import common from "../features/admin/common/Slice";

const foodservices = combineReducers({
    foodlabel,
    foodservice,
    common
});

export default foodservices;